import { useEffect, useState, useMemo } from "react";

/**
 * Renders an authenticated media file as a blob URL, so <img> and <video>
 * don't need to send Authorization headers (which they cannot).
 * Falls back to a soft placeholder on error.
 */
export default function MediaFile({ fileId, alt = "", className = "", asVideo = false }) {
  const [url, setUrl] = useState(null);
  const [err, setErr] = useState(false);

  const token = useMemo(() => localStorage.getItem("factskoot_token"), []);

  useEffect(() => {
    if (!fileId) return;
    let revoke;
    let ignore = false;
    (async () => {
      try {
        const base = process.env.REACT_APP_BACKEND_URL;
        const headers = token ? { Authorization: `Bearer ${token}` } : {};
        const resp = await fetch(`${base}/api/files/${fileId}`, {
          headers,
          credentials: "include",
        });
        if (!resp.ok) throw new Error("Not authorised");
        const blob = await resp.blob();
        const u = URL.createObjectURL(blob);
        revoke = u;
        if (!ignore) setUrl(u);
      } catch {
        if (!ignore) setErr(true);
      }
    })();
    return () => { ignore = true; if (revoke) URL.revokeObjectURL(revoke); };
  }, [fileId, token]);

  if (err) {
    return <div className={`bg-paper-alt text-ink-soft text-xs flex items-center justify-center ${className}`}>📷</div>;
  }
  if (!url) {
    return <div className={`bg-paper-alt animate-pulse ${className}`} />;
  }
  if (asVideo) return <video src={url} controls className={className} />;
  return <img src={url} alt={alt} className={className} />;
}
